import Icon from '../components/Icon.vue'

Icon.register({
  bug: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 288.9C511.5 306.3 496.8 320 479.3 320H424V336C424 357.9 419.1 378.6 410.4 397.1L470.6 457.4C483.1 469.9 483.1 490.1 470.6 502.6 458.1 515.1 437.9 515.1 425.4 502.6L370.6 447.9C345.9 468 314.4 480 280 480V236C280 229.4 274.6 224 268 224H244C237.4 224 232 229.4 232 236V480C197.6 480 166.1 468 141.4 447.9L86.6 502.6C74.1 515.1 53.9 515.1 41.4 502.6 28.9 490.1 28.9 469.9 41.4 457.4L101.6 397.1C92.9 378.6 88 357.9 88 336V320H32.7C15.2 320 0.5 306.3 0 288.9-0.5 270.8 14 256 32 256H88V197.3L41.4 150.6C28.9 138.1 28.9 117.9 41.4 105.4 53.9 92.9 74.1 92.9 86.6 105.4L141.3 160H370.7L425.4 105.4C437.9 92.9 458.1 92.9 470.6 105.4 483.1 117.9 483.1 138.1 470.6 150.6L424 197.3V256H480C498 256 512.5 270.8 512 288.9zM257 0C195.1 0 145 50.1 145 112H369C369 50.1 318.9 0 257 0z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bug.js
// module id = oLAb
// module chunks = 144